import { render, staticRenderFns } from "./chairs-a45.vue?vue&type=template&id=f5b0fd44&"
import script from "./chairs-a45.vue?vue&type=script&lang=js&"
export * from "./chairs-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports